/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Experience_PlaceholderInputs */

const en_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 5 years in frontend, led a team of 4, competing offer from...`)
};

const de_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 5 Jahre im Frontend, Team von 4 geleitet, Konkurrenzangebot von...`)
};

const fr_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 5 ans en frontend, dirigé une équipe de 4, offre concurrente de...`)
};

const es_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. 5 años en frontend, lideré un equipo de 4, oferta competidora de...`)
};

const it_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. 5 anni nel frontend, guidato un team di 4, offerta concorrente da...`)
};

const nl_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. 5 jaar frontend, team van 4 geleid, concurrerend aanbod van...`)
};

const pl_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. 5 lat we frontendzie, kierowałem zespołem 4 osób, konkurencyjna oferta od...`)
};

const fi_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. 5 vuotta frontend-kehityksessä, johdin 4 hengen tiimiä, kilpaileva tarjous...`)
};

const da_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. 5 års erfaring med frontend, ledte et team på 4, konkurrerende tilbud fra...`)
};

const sv_salary_negotiate_experience_placeholder = /** @type {(inputs: Salary_Negotiate_Experience_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. 5 års frontenderfarenhet, ledde ett team på 4, konkurrerande erbjudande från...`)
};

/**
* | output |
* | --- |
* | "e.g. 5 years in frontend, led a team of 4, competing offer from..." |
*
* @param {Salary_Negotiate_Experience_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_experience_placeholder = /** @type {((inputs?: Salary_Negotiate_Experience_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Experience_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_experience_placeholder(inputs)
	if (locale === "fr") return fr_salary_negotiate_experience_placeholder(inputs)
	if (locale === "es") return es_salary_negotiate_experience_placeholder(inputs)
	if (locale === "it") return it_salary_negotiate_experience_placeholder(inputs)
	if (locale === "nl") return nl_salary_negotiate_experience_placeholder(inputs)
	if (locale === "pl") return pl_salary_negotiate_experience_placeholder(inputs)
	if (locale === "fi") return fi_salary_negotiate_experience_placeholder(inputs)
	if (locale === "da") return da_salary_negotiate_experience_placeholder(inputs)
	if (locale === "sv") return sv_salary_negotiate_experience_placeholder(inputs)
	return en_salary_negotiate_experience_placeholder(inputs)
});